<div #captchaTemp class="captcha">
  <re-captcha class="g-recaptcha" #captchaRef="reCaptcha" [formControl]="control"
              (resolved)="resolved($event)" name="captcha" ngDefaultControl [size]="size === 'invisible' ? size : ''"
              [siteKey]="siteKey">
  </re-captcha>
  <!-- <small *ngIf="control?.hasError('required') && control.touched" class="error-message">Captcha validation is required</small> -->
  <small *ngIf="control?.hasError('required') && control.touched" class="error-message">Waiting for Captcha Verification...</small>
  <small *ngIf="control?.hasError('failed')" class="error-message">Captcha validation failed</small>
</div>
